import { inject, injectable } from 'tsyringe';
import { ApiInjectToken, MiddlewareInjectToken } from '../../constants/tokens';
import { Apis, CryptoCoin, MiddlewareConfig, Quote } from '../../types';
import { parseCryptoSymbol } from '../../utils';
import { QuoteApi } from '../QuoteApi';
import { TipranksApi } from '../TipranksApi';
import { availableCoins, AXOS_COIN } from './cryptoLookups';

@injectable()
export class AxosCryptoQuoteApi extends QuoteApi {
    constructor(
        @inject(MiddlewareInjectToken.Apis) apis: Apis,
        @inject(MiddlewareInjectToken.Config) config: MiddlewareConfig,
        @inject(ApiInjectToken.TipranksApi) protected override readonly tipranksApi: TipranksApi,
    ) {
        super(apis, config, tipranksApi);
    }

    override getStablecoin(): Promise<CryptoCoin | null> {
        return Promise.resolve<CryptoCoin>({
            name: 'Axos Stablecoin',
            symbol: AXOS_COIN,
        });
    }

    override getAvailableAssets(): Promise<CryptoCoin[]> {
        return Promise.resolve<CryptoCoin[]>(Object.values(availableCoins));
    }

    override getCoin(symbol: string): Promise<CryptoCoin | null> {
        const { base } = parseCryptoSymbol(symbol);
        return Promise.resolve(availableCoins[base] || null);
    }

    override async searchQuotes(criteria: string): Promise<Quote[]> {
        const assets = await this.getAvailableAssets();
        const foundAssets = assets.filter((asset) => asset.symbol.includes(criteria.toUpperCase()));
        const symbols = foundAssets.map((asset) => asset.symbol);
        const quotes = await this.getQuotes(symbols, true);
        return quotes;
    }

    override async getQuoteSet(): Promise<Quote[]> {
        const assets = await this.getAvailableAssets();
        const symbols = assets.map((asset) => asset.symbol);
        const quotes = await this.getQuotes(symbols, true);
        return quotes;
    }
}
